import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

const SEARCH_APPLICATIONS = gql`
  query GetApps(
        $organizationId: UUID!, 
        $term: String!, 
        $page: Int!,
        $applicationId: UUID,
        $assets: [UUID!],
        $types:  [UUID!],
        $statuses:  [UUID!],
        $pmStatuses:  [UUID!],
        $accounts:  [UUID!],
        $locations:  [UUID!],
        $stages:  [UUID!],
     ) {
    applicationSearch(
        organizationId: $organizationId, 
        term: $term, 
        page: $page,
        applicationId: $applicationId,
        assets: $assets,
        types: $types,
        statuses: $statuses,
        pmStatuses: $pmStatuses,
        accounts: $accounts,
        locations:$locations,
        stages: $stages,
        ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        address_full
        application_status
        application_stage
        application_type
        id_friendly
        pm_status
        asset_name
        
        tenants_signed
        deposit_paid
        submitter_name
        move_in
        move_out
        payments_pending
        unpaid_invoices
        
        created_ts
        updated_ts
        tenants {
          email
          first_name
          last_name
          phone_number
          signed
        }
      }
    }
  }
`;



export function apiSearchApplications(organizationId, term, page, applicationId, assets, types, stages, pmStatuses, accounts, locations, statuses) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: SEARCH_APPLICATIONS,
                variables: {
                    organizationId,
                    term,
                    page,
                    applicationId,
                    assets,
                    types,
                    stages,
                    pmStatuses,
                    accounts,
                    locations,
                    statuses
                },
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result?.data?.applicationSearch);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to search applications");
                reject(err); // R
            })
    });
}
